import React from "react";
import styles from "./ProfileFilterInput.module.scss";
import { combineClasses } from "../../utils/utils";
import Button from "components/UI/Button/Button";

const ProfileFilterInput = ({
  id,
  placeholder = "",
  required,
  disabled = false,
  value,
  onChange,
  onKeyDown,
  onAdd,
  showAddButton = true,
  addedItems = [],
  onRemoveItem,
  label,
  subLabel,
  className = "",
  // register,
  // validation,
  error,
}) => {
  return (
    <div className={combineClasses(styles.formField, className)}>
      <label htmlFor={id}>
        {label} {required && <span>*</span>}{" "}
        {subLabel && <span className={styles.subLabel}>{subLabel}</span>}
      </label>
      <div className={styles.skillsInputField}>
        <div className={styles.inputWithTags}>
          <input
            id={id}
            type="text"
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={onKeyDown}
            autoComplete="off"
            disabled={disabled}
          />
        </div>
        {showAddButton && (
          <Button variant="filled" className={styles.addBtn} type="button" onClick={onAdd} disabled={value.trim().length === 0}>
            Add
          </Button>
        )}
      </div>

      {addedItems.length > 0 && (<div className={styles.skillsInputWrapper}>
        <div className={styles.inputWithTags}>
          {addedItems.map((item, index) => (
            <div
              onClick={() => {
                if (!disabled) {
                  onRemoveItem(index);
                }
              }}
              key={index}
              className={styles.skillCard}
            >
              <p className={styles.skillsText}>{item}</p>
              {!disabled && (
                <button type="button" className={styles.removeBtn}>
                  ✕
                </button>
              )}
            </div>
          ))}
        </div>

        {/* {showAddButton && (
          <button className={styles.addBtn} type="button" onClick={onAdd}>
            Add
          </button>
        )} */}

        {error && <p className={styles.errorText}>{error}</p>}
      </div>)}
    </div>
  );
};

export default ProfileFilterInput;
